import { deepEqual } from 'lib/Helpers';

export const emptyFilter = [{ rules: [{ isValid: true }] }];
export const emptyFilterWithDateFilterValid = [{ rules: [{ isValid: true, isDateFilterValid: true }] }];
export const emptyFilterWithNullJoin = [{ rules: [{ isDateFilterValid: true, isValid: true, joinCondition: null }] }];

/**
 * Segments can only be saved if they are completed, but...
 * We want to support segments that include filters on only profiles or locations..
 * This return true for that use-case.
 * @function hasOnlyEmptyRule in SegmentBuilder
 * @param {Object} filters
 * @return {boolean}
 */
const hasOnlyEmptyRule = filters => {
  return deepEqual(filters, emptyFilter) ||
    deepEqual(filters, emptyFilterWithDateFilterValid) ||
    deepEqual(filters, emptyFilterWithNullJoin);
};

export default hasOnlyEmptyRule;
